import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade, AddressModel } from '../../../../common/models';
import { AddressOptionsDetailedLoad, AddressOptionsInitialState, AddressOptionsLoad } from './address-options.actions';
import { AddressOptionsState } from './address-options.state';
import { AddressDetailsModel } from '../models';

@Injectable({ providedIn: 'root' })
export class AddressOptionsFacade implements LoadDataFacade, SetInitialStateFacade {
  options$: Observable<AddressModel[]> = this.store.select(AddressOptionsState.getOptions);
  detailedOptions$: Observable<AddressDetailsModel[]> = this.store.select(AddressOptionsState.getDetailedOptions);
  loaded$: Observable<boolean> = this.store.select(AddressOptionsState.getLoaded);

  constructor(private store: Store) {}

  loadAll(filter: string): void {
    this.store.dispatch(new AddressOptionsLoad(filter));
  }

  loadAddressDetails(filter: string): void {
    this.store.dispatch(new AddressOptionsDetailedLoad(filter));
  }

  setInitialState(): void {
    this.store.dispatch(new AddressOptionsInitialState());
  }
}
